export default "/WavepathBlueLogo.svg";